export default {"src":"/_next/static/media/loading.443cdc83.gif","height":106,"width":106};